import React, { FC, PropsWithChildren } from 'react';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import i18n from 'i18n-js';
import { font } from '@styles/fonts';
import { scale } from '@components/frame';
import { isWeb } from '@helpers';
import { getBoxShadowStyle } from '@styles/shadow';
import ColorWrapper, { WithColor } from '@styles/colors';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export interface BlockWrapperProps extends WithColor, PropsWithChildren {
  title?: string;
  description?: string;
  marginBottom?: number;
  withoutShadow?: boolean;
  titleStyles?: StyleProp<ViewStyle>;
  descriptionStyles?: StyleProp<ViewStyle>;
}

const BlockWrapper: FC<BlockWrapperProps> = ({ C, children, marginBottom, title, description, withoutShadow, titleStyles, descriptionStyles }) => {
  return (
    <View style={[marginBottom != null && { marginBottom }]}>
      {title && (
        <Text style={[font.Footnote, { color: C('Label/Light/Tertiary'), paddingLeft: scale(15), paddingBottom: scale(5) }, titleStyles]}>
          {i18n.t(title)}
        </Text>
      )}
      <View
        style={[
          isWeb && !withoutShadow && getBoxShadowStyle({ type: 'Field', C }),
          { borderRadius: scale(SCREEN_BORDER_RADIUS) },
          !withoutShadow && { backgroundColor: C('Background/Light/Field') },
        ]}
      >
        {children}
      </View>
      {description && (
        <View style={[{ paddingLeft: scale(15), marginTop: scale(3) }, descriptionStyles]}>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{i18n.t(description)}</Text>
        </View>
      )}
    </View>
  );
};

export default ColorWrapper(BlockWrapper);
